<!-- 仓库管理 -->
<template>
    <div class="container">
        <div class="header">
            <img class="width_24 mr-12" src="../../assets/information.png">
            <div>
                <div>为规范业务，生成的码需要入库或调拨到对应的仓库，才会计入总部库存。</div>
                <div>仓库的库存总数非实时数据，每24小时更新一次。可通过清理缓存的方式，手动更新。</div>
            </div>
        </div>
        <div class="header-search">
            <Input class="w200 mr-24 mb-24" type="text" v-model="storePrams.name" clearable placeholder="请输入仓库名称、编号"></Input>
            <Button class="theme-bc mb-24" icon="ios-search" type="warning" @click="goSearch">确认搜索</Button>
        </div>
        <div class="content">
            <div>
                <Button class="theme-bc mr-24" type="warning" @click="goChangeData">新增仓库</Button>
                <Table class="mt-24" ref="selection" :columns="columnsTable" :data="dataTable" border @on-selection-change="changeSelection">
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <Button type="success" ghost label="small" @click="goJumpTo(row)">详情</Button>
                            <Button type="primary" ghost label="small" @click="goChangeData(row)">编辑</Button>
                            <Button type="error" ghost label="small" @click="goDel(1, row)">删除</Button>
                        </div>
                    </template>
                </Table>
            </div>
            <div class="page">
                <div>
                    <Checkbox class="checkbox-ml" v-model="del_value" @on-change="handleSelectAll">全选</Checkbox>
                    <span class="mr-24 ml-24">已经选择{{delData.length}}个</span>
                    <Button type="error" ghost label="large" @click="goDel(0)">删除</Button>
                </div>
                <Page :current="storePrams.page" :page-size="storePrams.limit" :total="total" show-elevator show-total @on-change="pageChange"/>
            </div>
        </div>
        <!-- 新增/编辑 -->
        <Modal v-model="changeModal" :title="changeTitle" width="500" :mask-closable="false">
            <div>
                <Form :model="formData" label-position="right" :label-width="100">
                    <FormItem label="仓库名称：">
                        <Input type="text" v-model="formData.name" placeholder="请输入仓库名称"></Input>
                    </FormItem>
                    <FormItem label="仓库编号：">
                        <Input type="text" v-model="formData.number" placeholder="请输入仓库编号"></Input>
                    </FormItem>
                    <FormItem label="仓库地址：">
                        <Input type="text" v-model="formData.address" placeholder="请输入仓库地址"></Input>
                    </FormItem>
                    <FormItem label="联系电话：">
                        <Input type="text" v-model="formData.concat_way" placeholder="请输入联系电话"></Input>
                    </FormItem>
                    <FormItem label="联系人：">
                        <Input type="text" v-model="formData.concats" placeholder="请输入联系人"></Input>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button @click="removeModal">取消</Button>
                <Button class="theme-bc" type="warning" @click="submitModal">确定</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import { 
    warehouse_list, 
    warehouse_delete, 
    warehouse_save,
} from '@/api/index';
export default {
    data() {
        return {
            storePrams: {
                page: 1,
                limit: 10,
                name: '',
            },
            total: 0,
            columnsTable: [
                { type: 'selection', width: 60, align: 'center' },
                { type: 'index', width: 60, align: 'center' },
                { title: "仓库名称", key: "name", align: "center" },
                { title: "仓库编号", key: "number", align: "center" },
                { title: "仓库地址", key: "address", align: "center" },
                { title: "联系方式", key: "concat_way", align: "center" },
                { title: "库存数量", key: "qrcode_count", align: "center" },
                { title: "操作", slot: "operate", align: "center", width: "250px" },
            ],
            dataTable: [],
            changeModal: false,
            changeTitle: "",
            formData: { 
                name: "",
                number: "",
                address: "",
                concat_way: "",
                concats: "",
                id: "",
            },
            productList: [
                { id: 1, name: "产品1" },
                { id: 2, name: "产品2" },
                { id: 3, name: "产品3" },
            ],
            batchList: [
                { id: 1, name: "批次1" },
                { id: 2, name: "批次2" },
                { id: 3, name: "批次3" },
            ],
            storeList: [
                { id: 1, name: "仓库1" },
                { id: 2, name: "仓库2" },
                { id: 3, name: "仓库3" },
            ],
            agentList: [
                { id: 1, name: "代理商1" },
                { id: 2, name: "代理商2" },
                { id: 3, name: "代理商3" },
            ],
            // selection
            del_id: "",
            delData: [],
            del_value: false,
            columnsDrawer: [
                { title: "#", slot: "id", align: "center", width: "60px" },
                { title: "产品图片", slot: "picture", align: "center" },
                { title: "产品名称及规格", key: "name", align: "center" },
                { title: "溯源码编码", key: "qr_code", align: "center" },
                { title: "关联批次", key: "batch", align: "center" },
                { title: "关联箱码", key: "case_code", align: "center" },
                { title: "当前仓库", key: "store", align: "center" },
                { title: "码状态", slot: "quantity", align: "center" },
                { title: "操作", slot: "operate", align: "center" },
            ],
            dataDrawer: [],
            pagesDrawer: {
                page: 1,
                limit: 10,
            },
            totalDrawer: 0,
        };
    },
    mounted() {
        this.getList();
    },
    methods: {
        goSearch(){
            this.storePrams.page = 1;
            this.getList();
        },
        getList() {
            warehouse_list(this.storePrams).then((res) => {
                this.dataTable = res.data.data;
                this.total = res.data.total;
                // 删除后，page--
                if(!res.data.data.length && this.storePrams.page != 1){
                    this.storePrams.page --;
                    this.getList();
                }
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        getDrawer() {
            apilist(this.pagesDrawer).then((res) => {
                this.dataDrawer = res.data.data;
                this.totalDrawer = res.data.total;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        changeDrawer(index) {
            this.pagesDrawer.page = index;
            this.getDrawer();
        },
        goDel(index, row){
            if(index == 0 && this.delData.length == 0){
                this.$Message.error('请选择');
                return
            }
            let that = this;
            this.$Modal.confirm({
                title: '删除提示',
                content: '确认删除吗？一经删除无法复原',
                onOk: () => {
                    if(index == 0){
                        var del_id = [];
                        this.delData.forEach(item => {
                            del_id.push(item.id)
                        });
                        this.del_id = del_id.join(',');
                        warehouse_delete({ id: this.del_id }).then(res=>{
                            that.getList();
                            this.del_value = false;
                            this.$Message.success(res.msg);
                        }).catch(res=>{
                            this.$Message.error(res.msg);
                        })
                    }else if(index == 1){
                        warehouse_delete({ id:row.id }).then(res=>{
                            that.getList();
                            this.$Message.success(res.msg);
                        }).catch(res=>{
                            this.$Message.error(res.msg);
                        })
                    }
                },
                onCancel: () => {
                }
            }); 
        },
        goChangeData(row){
            if(row.id){
                this.changeTitle = '编辑仓库';
                this.formData.name = row.name;
                this.formData.number = row.number;
                this.formData.address = row.address;
                this.formData.concat_way = row.concat_way;
                this.formData.concats = row.concats;
                this.formData.id = row.id;
            }else{
                this.changeTitle = '新增仓库';
                this.formData.name = "";
                this.formData.number = "";
                this.formData.address = "";
                this.formData.concat_way = "";
                this.formData.concats = "";
                this.formData.id = "";
            }
            this.changeModal = true;
        },
        removeModal(){
            this.changeModal = false;
        },
        // 确定 -- 新增/编辑
        submitModal(){
            warehouse_save(this.formData).then( res => {
                this.getList();
                this.changeModal = false;
                this.$Message.success(res.msg);
            }).catch(res=>{
                this.$Message.error(res.msg);
            }) 
        },
        // selection
        changeSelection(e){
            this.delData = e;
            if(this.dataTable.length === e.length){
                this.del_value = true;
            }else{
                this.del_value = false;
            }
        },
        handleSelectAll(e){
            if(e == true){
                this.delData = this.dataTable;
                this.$refs.selection.selectAll(true);
            }else{
                this.$refs.selection.selectAll(false);
            }
        },
        goJumpTo(row){
            this.$router.push({ path: `/admin/warehouse/parent?id=${row.id}` });
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.header {
    margin-bottom: 24px;
    padding: 24px;
    background: rgba(255,118,29,0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
}
.header-search {
    padding: 24px 24px 0 24px;
    margin-bottom: 24px;
    background-color: #fff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.width_24 {
    width: 24px;
    height: 24px;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    height: 100%;
}
.page {
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
}
.footer {
    position: absolute;
    right: 20px;
    bottom: 20px;
}
::v-deep .ivu-input-search {
    background: #53C41A !important;
    border-color: #53C41A !important;
}
::v-deep .ivu-radio-group-button .ivu-radio-wrapper-checked {
    background: #53C41A;
    border-color: #53C41A;
    box-shadow: -1px 0 0 0 #53C41A;
    border-radius: 5px;
    color: #fff;
    z-index: 1;
}
::v-deep .ivu-checkbox{
    margin-right: 24px;
}
::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: #ff761d;
    background-color: #ff761d;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
.checkbox-ml {
    margin-left: 20px !important;
}
</style>